<p-overlayPanel #overlay 
                [appendTo]="'body'" 
                [styleClass]="'search-type-overlay'"
                (onShow)="onOverlayShow()"
                (onHide)="onOverlayHide()">
  <div [ngClass]="{ 'he': currentLanguage === 'he', 'en': currentLanguage === 'en' }"
       (click)="$event.stopPropagation()"
       (keydown)="handleKeydown($event)">
    <h4 class="search-type-title" [id]="'searchTypeTitle-' + uniqueId">{{ 'iaa.app.advancedSearch.searchDepth' | translate }}</h4>
    <div class="search-type-selector" role="radiogroup" [attr.aria-labelledby]="'searchTypeTitle-' + uniqueId">
      <div *ngFor="let option of searchTypeOptions; let i = index" 
           class="search-type-option">
        <input type="radio"
               [name]="'searchType-' + uniqueId"
               [value]="option.value" 
               [(ngModel)]="currentValue"
               [id]="'searchType-' + uniqueId + '-' + option.value"
               class="radio-input"
               (click)="onRadioClick()"
               (keydown.enter)="$event.preventDefault(); confirmSelection()"
               (keydown.space)="$event.preventDefault(); confirmSelection()">
        <label [for]="'searchType-' + uniqueId + '-' + option.value" 
               class="option-content"
               (click)="onLabelClick()">
          <span class="option-label">{{ option.label }}</span>
          <img [src]="option.icon" [alt]="option.label" class="option-icon" />
        </label>
      </div>
    </div>
  </div>
</p-overlayPanel>
